import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  padding-right: 10px;
  border-right: 1px solid ${({ theme }) => theme.backgrounds.summaryFilter};
  margin-bottom: auto;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.modalTitle};
  text-transform: uppercase;
`;
Title.displayName = 'Title';

export const Description = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.text.modalDescription};
`;
Description.displayName = 'Description';

export const Agent = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.buttons.primary.background}
`;
Agent.displayName = 'Agent';
